import React from 'react';
import PropTypes from 'prop-types';
import { TextField, SimpleShowLayout, FunctionField } from 'react-admin';
import Header from '../../../shared/header';
import { getCountryName } from '../../../shared/country';

export const BusinessAddress = ({ resource, record, classes, isItaly }) => (
  <SimpleShowLayout resource={resource} record={record}>
    <Header label="resources.business.businessAddress" />
    <TextField
      source="address.streetName"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Business-Address-streetName"
    />
    <TextField
      source="address.postalCode"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Business-Address-postalCode"
    />
    <TextField
      source="address.city"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Business-Address-City"
    />
    <FunctionField
      label="resources.business.fields.address.country"
      className={classes.field}
      classes={{ root: classes.fieldContent }}
      id="Selenium-businessDetails-Business-Address-Country"
      render={r => getCountryName(r.address && r.address.countryCode)}
    />
    {isItaly && (
      <TextField
        source="address.region"
        label="resources.business.fields.mainRegion"
        className={classes.field}
        classes={{ root: classes.fieldContent }}
        id="businessMainAddress"
      />
    )}
  </SimpleShowLayout>
);

BusinessAddress.propTypes = {
  record: PropTypes.shape({}),
  classes: PropTypes.shape({
    field: PropTypes.string,
    fieldContent: PropTypes.string,
  }),
  resource: PropTypes.string,
  isItaly: PropTypes.bool,
};
